<div class="page">
  <div style="display: flex;width: 100%; justify-content: center;align-content: center;align-items: center;">
    <div class="logo" >
      <img src="assets/logo-cardcol.svg" height="120px"/>
    </div>
  </div>
</div>
